module.exports = __webpack_public_path__ + "assets/img/pyramid_text.6aabe354.png";